import mvtInputGeo from '@/common/components/mvtinputgeo/mvt-inputgeo.vue';
import mvtWelcome from '@/common/components/mvtwelcome/mvt-welcome.vue';
import mvtDialog from '@/common/components/mvtdialog/mvt-dialog.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'valuationWelcome',
    inject: ['$eventBus'],
    components: {
        mvtInputGeo,
        mvtWelcome,
        mvtDialog
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb'])
    },
    methods:{
        openDisclaimer() {
            this.$refs.avmDisclaimer.show('avmDisclaimer', this.$options.name);
        },
    },
    data: function() {
        return {
            formState:'',
            geoInfo: {
                text: '',
                geo: null
            }
        }
    },
    watch:{
        geoInfo(newVal){
            if(newVal){
                this.$eventBus.$emit('eventbus-search-address',{
                    text: newVal.text,
                    geo: newVal.geo,
                    extraPath: '?simple=price&addfav'
                });
            }
        }
    },
};